import Reveal from "./Reveal";
import { PAPENBURG_DISCOVER, CONTACT, IMAGES } from "@/data/content";

export default function PapenburgDiscover() {
    return (
        <section
            id="papenburg"
            data-testid="papenburg-section"
            className="section-y relative bg-muted/40"
        >
            <div className="container-em">
                <div className="grid lg:grid-cols-12 gap-10 md:gap-16 items-start">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                                Wohnen in Papenburg
                            </span>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2
                                data-testid="papenburg-title"
                                className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-balance"
                            >
                                Deine Wohnung in{" "}
                                <em className="not-italic text-primary">
                                    Papenburg
                                </em>{" "}
                                – mitten im Emsland.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <p className="mt-6 text-foreground/75 text-lg leading-relaxed">
                                {PAPENBURG_DISCOVER.intro}
                            </p>
                        </Reveal>
                        <Reveal delay={0.15}>
                            <p className="mt-4 text-foreground/70 text-base leading-relaxed">
                                Ob als Ferienwohnung Papenburg für den
                                Kurzurlaub, als Wohnung auf Zeit für
                                Projekteinsätze bei der Meyer Werft oder als
                                komfortable Unterkunft für Familien – das
                                Emsglück ist Dein Rückzugsort in ruhiger Lage,
                                zentral zwischen Innenstadt, Ems und
                                Ausflugszielen im gesamten Emsland und
                                Ostfriesland.
                            </p>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <a
                                href="#anfrage"
                                data-testid="papenburg-inquiry-button"
                                className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-medium hover:bg-primary/90 transition-all duration-300 hover:-translate-y-0.5"
                            >
                                Unverbindlich anfragen
                            </a>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-7">
                        <div className="grid sm:grid-cols-2 gap-4">
                            {PAPENBURG_DISCOVER.highlights.map((h, i) => (
                                <Reveal
                                    key={h.title}
                                    delay={i * 0.06}
                                    className="h-full"
                                >
                                    <div
                                        data-testid="papenburg-highlight"
                                        className="h-full rounded-3xl bg-card border border-border/60 p-6 hover:border-primary/40 transition-all duration-300 hover:-translate-y-1"
                                    >
                                        <p className="font-display text-xl text-foreground leading-snug">
                                            {h.title}
                                        </p>
                                        <p className="mt-2 text-foreground/70 text-sm leading-relaxed">
                                            {h.text}
                                        </p>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                        <Reveal delay={0.25}>
                            <div className="mt-4 overflow-hidden rounded-3xl aspect-[16/9] shadow-[0_20px_60px_-24px_rgba(60,60,50,0.25)]">
                                <img
                                    src={IMAGES.kuecheWeiss}
                                    alt="Voll ausgestattete Küche der Ferienwohnung in Papenburg – ideal für Selbstversorger"
                                    loading="lazy"
                                    className="w-full h-full object-cover transition-transform duration-[1400ms] hover:scale-105"
                                />
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
